import { Box, Container, Link, Typography, styled } from '@mui/material';
import packageJson from '../../../package.json';
import { WEBSITE_URL } from '../../constants';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

export const Footer = () => {
  const appVersion = packageJson.version;

  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        pb={4}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">
            &copy; Stay connected and protected
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItem: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="subtitle1">
            Crafted by{' '}
            <Link href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
              eSIMo.io
            </Link>
          </Typography>
          <Typography variant="subtitle1">v.{appVersion}</Typography>
        </Box>
      </Box>
    </FooterWrapper>
  );
};
